import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const HorizontalContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const GroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border-radius: 10px;
  border: 1px solid transparent;
  line-height: normal;
  &:hover {
    border-color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

export const GroupItemText = styled.div<{ $isVisible: boolean }>`
  font-weight: 500;
  font-size: 12px;
  color: ${({ $isVisible }) =>
    $isVisible ? theme.colors.secondary800 : 'inherit'};
`;
